import React, { useContext } from "react";
import { toast } from "../../utils/toast";
import AppContext from "../../context/AppContext";
import translations from "../../components/common/Translations";
import { ChevronLeft, ChevronRight } from "lucide-react";

const DynamicPage = ({ page, setPage, dragItems, totalPages, trailingSlot }) => {
  const { theme, langMode } = useContext(AppContext);
  const safeTotalPages = Math.max(1, Number(totalPages) || 1);
  const safeCurrentPage = Math.min(Math.max(1, Number(page) || 1), safeTotalPages);
  const isPrevDisabled = page <= 1;
  const isNextDisabled = page >= safeTotalPages;
  const handleIncrement = () => {
    let containsItem = dragItems.findIndex((item) => item.page === page);
    if (containsItem >= 0) {
      setPage((prevPage) => prevPage + 1);
    } else {
      toast.warning(
        translations[langMode].addleastonelementto
      );
    }
  };
  const handleDecrement = () => {
    setPage((prevPage) => {
      return prevPage > 1 ? prevPage - 1 : prevPage;
    });
  };
  return (
    <>
      <div
        className={`w-full ${theme === "dark"
          ? "dark-mode "
          : theme === "high-contrast"
            ? "high-contrast"
            : ""
          }`}
      >
        <div className="grid w-full grid-cols-[auto_1fr_auto] items-center gap-3 whitespace-nowrap">
          <div className="flex items-center gap-2">
            <div className="text-[13.5px] font-normal text-slate-800">
              {translations[langMode].Page}
            </div>
            <span className="inline-flex h-7 min-w-7 items-center justify-center rounded-full bg-slate-100 px-2 text-xs font-semibold text-slate-700">
              {safeCurrentPage}
            </span>
          </div>
          <div className="flex items-center justify-center gap-2">
            <button
              type="button"
              onClick={handleDecrement}
              disabled={isPrevDisabled}
              className="inline-flex h-[30px] w-[30px] shrink-0 items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-600 transition-colors duration-150 hover:border-[#BEDAF0] hover:bg-[#EAF3FB] hover:text-[#236DB4] focus:outline-none disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-slate-200 disabled:hover:bg-white disabled:hover:text-slate-600"
            >
              <ChevronLeft size={16} />
            </button>

            <span className="inline-flex min-w-[96px] items-center justify-center rounded-lg border border-slate-200 bg-slate-50 px-3.5 py-1.5 text-[13.5px] font-normal text-slate-800">
              {translations[langMode].Page}&nbsp;<b className="text-[#236DB4]">{page}</b>&nbsp;{translations[langMode].of}&nbsp;{safeTotalPages}
            </span>

            <button
              type="button"
              onClick={handleIncrement}
              disabled={isNextDisabled}
              className="inline-flex h-[30px] w-[30px] shrink-0 items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-600 transition-colors duration-150 hover:border-[#BEDAF0] hover:bg-[#EAF3FB] hover:text-[#236DB4] focus:outline-none disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-slate-200 disabled:hover:bg-white disabled:hover:text-slate-600"
            >
              <ChevronRight size={16} />
            </button>
          </div>
          <div className="flex justify-end">
            {trailingSlot ?? (
              <span className="inline-flex h-8 w-8 rounded-[10px] border border-slate-200 bg-white" />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default DynamicPage;
